import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FilterItemDto } from '@/app/shared/models/misc';
import { ToggleComponent } from '@/app/atoms/form-components/toggle/toggle.component';
import { BUTTON_CATALOG } from './buttons.types';

@Component({
  selector: 'admin-branding-buttons',
  templateUrl: './buttons.html',
  host: { class: 'block h-full w-full min-h-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToggleComponent],
})
export class Buttons {
  readonly groups = BUTTON_CATALOG;

  readonly buttonStateOptions: FilterItemDto[] = [
    { id: 1, name: 'Enabled', value: true },
    { id: 2, name: 'Disabled', value: false },
  ];

  readonly disabledSampleIds = signal<ReadonlySet<string>>(this.initialDisabledSampleIds());

  isSampleDisabled(sampleId: string): boolean {
    return this.disabledSampleIds().has(sampleId);
  }

  selectedOptionFor(sampleId: string): FilterItemDto {
    return this.isSampleDisabled(sampleId)
      ? this.buttonStateOptions[1]
      : this.buttonStateOptions[0];
  }

  onToggle(sampleId: string, option: FilterItemDto): void {
    const enabled = option === this.buttonStateOptions[0];
    this.disabledSampleIds.update((ids) => {
      const next = new Set(ids);
      if (enabled) {
        next.delete(sampleId);
      } else {
        next.add(sampleId);
      }
      return next;
    });
  }

  private initialDisabledSampleIds(): Set<string> {
    return new Set(
      BUTTON_CATALOG.flatMap((group) => group.samples)
        .filter((sample) => sample.state === 'disabled')
        .map((sample) => sample.id),
    );
  }
}
